export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-white/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="font-heading text-lg font-bold text-white mb-4">刃牙漫画</h3>
            <p className="text-sm leading-relaxed text-white/55">
              刃牙漫画完整版大合集，一次性收录全部章节。刃牙漫画大全从第一部到最新，下拉式畅享全系列。热血格斗经典，尽在刃牙漫画。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '焦点专题', href: '#carousel' },
                { label: '主题索引', href: '#index' },
                { label: '更新快讯', href: '#updates' },
                { label: '热度榜单', href: '#ranking' },
                { label: '推荐阅读', href: '#cards' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.querySelector(item.href);
                      if (el) el.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-white/55 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">帮助中心</h4>
            <ul className="space-y-2.5">
              {[
                { label: '常见问题', href: '#faq' },
                { label: '关于我们', href: '#about' },
                { label: '平台特色', href: '#features' },
                { label: '联系我们', href: '#contact' },
                { label: '移动阅读', href: '#app' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.querySelector(item.href);
                      if (el) el.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-white/55 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              更多合作伙伴即将加入，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/35">
            &copy; {new Date().getFullYear()} 刃牙漫画 - 本站内容仅供学习交流使用
          </p>
          <div className="flex items-center gap-5">
            <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-white/35 hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">回到顶部</a>
            <span className="text-xs text-white/35">|</span>
            <span className="text-xs text-white/35">刃牙漫画在线免费看</span>
          </div>
        </div>
      </div>
    </footer>
  );
}